var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"wabident-selector",attrs:{"id":_vm.name,"item-text":"label","item-value":"value","options":_vm.options,"placeholder":"Categoría de producto ..."},on:{"input":_vm.change},model:{value:(_vm.selected_category),callback:function ($$v) {_vm.selected_category=$$v},expression:"selected_category"}})
}
var staticRenderFns = []

export { render, staticRenderFns }